import Vue from 'vue'
import PDF from 'vue-pdf'

export default PDF
Vue.component('pdfjs', PDF)
Vue.prototype.$pdf = PDF